import React from 'react';
import { keyBoardAccessibilityAttributes } from '../../../../../../utils/GeneralUtils';
import LazyloadImage from '../../../../../generic/Utils/LazyloadImage';
import ChrLink from '../../../../../generic/Utils/ChrLink';

const Content = ({ linkAttributes, image, setAccessibilityAttributes }) => {
  return(
    <ChrLink
      { ...(setAccessibilityAttributes && keyBoardAccessibilityAttributes) }
      { ...linkAttributes }
    >
      <LazyloadImage
        source={ image.url }
        className="cui-events-listing-image"
        alt={ image.alt }
      />
    </ChrLink>
  );
};

const Image = ({ linkAttributes, image, setAccessibilityAttributes }) => {
  return(
    <>
      <div className='d-none d-md-flex mr-3'>
        <Content
          linkAttributes={ linkAttributes }
          image={ image }
          setAccessibilityAttributes={ setAccessibilityAttributes }
        />
      </div>

      <div className="col-12 cui-flex-with-contents-centered col-sm-auto mb-4 mb-sm-0 mr-3 p-0 d-md-none">
        <Content
          linkAttributes={ linkAttributes }
          image={ image }
          setAccessibilityAttributes={ setAccessibilityAttributes }
        />
      </div>
    </>
  )
};

export default Image;
